export default __webpack_public_path__ + "static/media/excelicon.11a619ff.png";